document.addEventListener('DOMContentLoaded', function() {
	const load_btn = document.querySelector(".custom-filter-load-more");
	const infinite_scroll = document.querySelector('.infinite-scroll');
	let articles_on_page = document.querySelector('#qf-article-filter-wrapper .article-grid'); // Target the main grid specifically
	let url = articles_on_page?.getAttribute('data-next-url');
	const spinner = document.querySelector('.spinner');

	if (!articles_on_page) return;

	const load_more = () => {
		if (spinner) {
			spinner.classList.add("show");
		}

		if (load_btn) {
			load_btn.style.pointerEvents = 'none';
			load_btn.style.opacity = '0.5';
		}

		fetch(url)
			.then(function (response) {
				if (response.ok) {
					return response.text();
				} else {
					throw new Error('Network response was not ok.');
				}
			})
			.then(function (data) {
				const html = document.createElement('div');
				html.innerHTML = data;

				let links = html.querySelector('.pagination-links');
				let current_pagination = document.querySelector('.pagination-links');
				
				if (links && current_pagination) {
					current_pagination.innerHTML = links.innerHTML;
				}

				let new_grid = html.querySelector('#qf-article-filter-wrapper .article-grid'); // Also target specifically here
				if (new_grid) {
					url = new_grid.getAttribute('data-next-url');
					if (!url || url === '') {
						if (load_btn) load_btn.style.display = 'none';
					}
					
					let new_articles = new_grid.querySelectorAll(".article-card");
					new_articles.forEach(new_article => {
						articles_on_page.append(new_article);
					});
				}

				if (spinner) {
					spinner.classList.remove("show");
				}

				if (load_btn) {
					load_btn.style.pointerEvents = 'auto';
					load_btn.style.opacity = '1';
				}
			})
			.catch(function (error) {
				console.error('Load more error:', error);
				if (spinner) {
					spinner.classList.remove("show");
				}
				if (load_btn) {
					load_btn.style.pointerEvents = 'auto';
					load_btn.style.opacity = '1';
				}
			});
	}

	if (load_btn) {
		if (!url || url === '') {
			load_btn.style.display = 'none';
		}

		load_btn.addEventListener("click", () => {
			load_more();
		});

		if (infinite_scroll) {
			const options = {
				root: null,
				rootMargin: '300px',
				threshold: 0.1
			}

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting && url && url !== '') {
						load_more();
					}
				});
			}, options);

			observer.observe(infinite_scroll);
		}
	}
});